export const SECTOR_FETCH = 'SECTOR_FETCHY'
export const SECTOR_CREATE = 'SECTOR_CREATE'
export const SECTOR_UPDATE = 'SECTOR_UPDATE'
